import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function slotsRouteI18n(): string {
  return (appRoutesI18nCache['slots'] ??= $localize`:url-segment@@slots-url-segment:slots`);
}
